//===============================================================================
// © 2017 eWorkplace Apps.  All rights reserved.
// Original Author: Sanjeev Khanna
// Original Date: 18 July 2017
//==============================================================================
import { Injectable } from '@angular/core';

declare var swal: any;
@Injectable()
export class BootstrapSWAlertService {
    constructor() {

    }

    /**
     * Show alert message
     * @param msg 
     */
    showAlert(msg: string): void {
        swal(msg);
    }

    /**
     * Show alert message with title
     * @param title: Title  
     * @param msg: Message 
     */
    showAlertWithtitle(title: string, msg: string): void {
        swal(msg);
    }

    /**
     * Show confirmation alert with deligate handler
     * @param title: Tilte 
     * @param onOk: On Ok Handler 
     * @param onCancel: On Cancel Handler 
     */
    showConfirmationAlert(title: string, onOk, onCancel): void {
        swal({
            title: title,
            text: "",
            type: "warning",
            showCancelButton: true,
            confirmButtonClass: "btn-danger",
            confirmButtonText: "Delete",
            cancelButtonText: "Cancel",
            closeOnConfirm: false,
            closeOnCancel: false
        }, function (isConfirm) {
            if (isConfirm) {
                swal.close();
                this.showLoader = true;
                onOk();
            } else {
                swal.close();
                onCancel();
            }
        });
    }

    /**
     * Show Information confirmation alert
     * @param title: Title 
     * @param msg: Message    
     * @param onOk: On Ok Handler 
     * @param onCancel: On Cancel Handler 
     */
    showInformationAlert(title: string, msg: string, onOk, onCancel) {
        swal({
            title: title,
            text: "You will not be able to recover this imaginary file!",
            type: "warning",
            showCancelButton: true,
            confirmButtonClass: "btn-danger",
            confirmButtonText: "Yes, delete it!",
            cancelButtonText: "No, cancel plx!",
            closeOnConfirm: false,
            closeOnCancel: false
        },
            function (isConfirm) {
                if (isConfirm) {
                    swal("Deleted!", "Your imaginary file has been deleted.", "success");
                } else {
                    swal("Cancelled", "Your imaginary file is safe :)", "error");
                }
            });
    }

    /**
     * Show alert with Input
    * @param title: Tilte 
    * @param msg: Display Message 
    * @param onOk: On Ok Handler 
    * @param onCancel: On Cancel Handler          
     */
    showConfirmationWithInput(title: string, msg: string, onOk, onCancel) {
        swal({
            title: title,
            text: "Write something interesting:",
            type: "input",
            showCancelButton: true,
            closeOnConfirm: false,
            inputPlaceholder: "Write something"
        }, function (inputValue) {
            if (inputValue === false) return false;
            if (inputValue === "") {
                swal.showInputError("You need to write something!");
                return false
            }
            swal("Nice!", "You wrote: " + inputValue, "success");
        });
    }

    /**
     * Show Confirmation with Ajax request
     * @param title: Title 
     * @param msg: Message 
     * @param onOk: On Ok Handler 
     * @param onCancel: On Cancel Handler   
     */
    showConfirmationWithAjax(title: string, msg: string, onOk, onCancel) {
        swal({
            title: title,
            text: "Submit to run ajax request",
            type: "info",
            showCancelButton: true,
            closeOnConfirm: false,
            showLoaderOnConfirm: true
        }, function () {
            setTimeout(function () {
                swal("Ajax request finished!");
            }, 2000);
        });
    }
}


// WEBPACK FOOTER //
// /Users/hrushabhmakwana/Documents/CAM/CreditRepairMenAngular/src/app/common/services/bootstrap-SWAlert.service.ts